// Types
import { Code } from '../objects/code';
import { Column } from '../objects/column';
import { Contact } from '../objects/contact';
import { Contract } from '../objects/contract';
import { PaymentDelay } from '../objects/paymentDelay';
import { Preferences } from '../../profile/objects/preferences';
import { BankingInformation } from '../objects/bankingInformation';
import { CustomProviderState } from '../objects/customProviderState';
// Action Types
import {
    ADD_BANKING_INFORMATION,
    ADD_CODE,
    ADD_CONTACT,
    ADD_CONTRACT,
    ADD_PAYMENT_DELAY,
    ADD_PREFERENCES,
    CustomProviderActionTypes,
    DELETE_BANKING_INFORMATION,
    DELETE_CODE,
    DELETE_CONTACT,
    DELETE_CONTRACT,
    DELETE_PAYMENT_DELAY,
    MOVE_DOWN_COLUMN,
    MOVE_UP_COLUMN,
    RESET_CUSTOM_PROVIDER,
    RESET_FILTERS,
    SET_BANKING_INFORMATION_DELETE,
    SET_BANKING_INFORMATION_LIST,
    SET_CODE_DELETE,
    SET_CODE_LIST,
    SET_CONTACT_DELETE,
    SET_CONTACT_LIST,
    SET_CONTRACT_ACTIVATE,
    SET_CONTRACT_LIST,
    SET_CONTRACT_LOCK,
    SET_CUSTOM_PROVIDER,
    SET_CUSTOM_PROVIDER_ACTIVATE,
    SET_CUSTOM_PROVIDER_BANKING_INFORMATIONS,
    SET_CUSTOM_PROVIDER_CODES,
    SET_CUSTOM_PROVIDER_CONTACTS,
    SET_CUSTOM_PROVIDER_CONTRACTS,
    SET_CUSTOM_PROVIDER_PAYMENT_DELAYS,
    SET_EDIT_STEP,
    SET_ERRORS,
    SET_EXPORT_TYPE,
    SET_LIMIT,
    SET_LIST,
    SET_LIST_CONTRACT_RELOAD,
    SET_ORDER_BY,
    SET_PAGE,
    SET_PAYMENT_DELAYS_DELETE,
    SET_PICTURE_ERRORS,
    SET_POST_FINISHED,
    SET_PREFERENCES as SET_CUSTOM_PROVIDER_PREFERENCES,
    SET_RUNNING,
    SET_SEARCH,
    TOGGLE_AUTO_BOOKING,
    TOGGLE_COLUMN,
    TOGGLE_CREATE,
    TOGGLE_EDIT,
    TOGGLE_EXPORT,
    TOGGLE_EXPORT_FULL,
    TOGGLE_FILTERS,
    TOGGLE_REFRESH,
    UPDATE_ACTIVATION_COUNTRIES,
    UPDATE_ADDRESS,
    UPDATE_ASSISTANCE_EMAIL,
    UPDATE_ASSISTANCE_PHONE_NUMBER,
    UPDATE_BANKING_ACCOUNT_HOLDER,
    UPDATE_BANKING_ADDRESS,
    UPDATE_BANKING_BIC,
    UPDATE_BANKING_CITY,
    UPDATE_BANKING_COUNTRY,
    UPDATE_BANKING_CURRENCY,
    UPDATE_BANKING_IBAN,
    UPDATE_BANKING_NAME,
    UPDATE_BANKING_ZIP_CODE,
    UPDATE_BOOKING_EMAIL,
    UPDATE_CITY,
    UPDATE_CODE,
    UPDATE_CODE_CODE,
    UPDATE_CODE_CURRENCY,
    UPDATE_COMPLEMENTARY_ADDRESS,
    UPDATE_CONTACT_CONTACT_EMAIL, UPDATE_CONTACT_DETAILS_LOCALE,
    UPDATE_CONTACT_EMAIL,
    UPDATE_CONTACT_FIRST_NAME,
    UPDATE_CONTACT_FUNCTION,
    UPDATE_CONTACT_LAST_NAME,
    UPDATE_CONTACT_PHONE_NUMBER,
    UPDATE_CONTENT_TYPE,
    UPDATE_CONTRACT_CURRENCY,
    UPDATE_CONTRACT_EVENT_SITE_DATE,
    UPDATE_CONTRACT_END_DATE,
    UPDATE_CONTRACT_NAME,
    UPDATE_CONTRACT_SECOND_STOCK_TYPE,
    UPDATE_CONTRACT_START_DATE,
    UPDATE_CONTRACT_STOCK_TYPE,
    UPDATE_CONTRACT_TYPE,
    UPDATE_COUNTRY,
    UPDATE_FILTER_ACTIVATED,
    UPDATE_FILTER_CONTENT_TYPE,
    UPDATE_FILTER_CREATED_DATE_GTE,
    UPDATE_FILTER_CREATED_DATE_LTE,
    UPDATE_FILTER_CREATOR,
    UPDATE_FILTER_LAST_AUTHOR,
    UPDATE_FILTER_MODIFIED_DATE_GTE,
    UPDATE_FILTER_MODIFIED_DATE_LTE,
    UPDATE_FILTER_NAME,
    UPDATE_FILTER_PERIOD,
    UPDATE_FILTER_PERIOD_TYPE,
    UPDATE_FILTER_VA_CONTENT_TYPE,
    UPDATE_LANGUAGE,
    UPDATE_NAME,
    UPDATE_PAYMENT_DELAY,
    UPDATE_PAYMENT_TYPE,
    UPDATE_PHONE_NUMBER,
    UPDATE_PICTURE,
    UPDATE_PICTURE_PROGRESS,
    UPDATE_SECONDARY_PHONE_NUMBER,
    UPDATE_VA_CONTENT_TYPE,
    SET_PAYMENT_DELAY_CREATE,
    UPDATE_ZIP_CODE,
    UPDATE_CONTRACT_NAME_LOCALE,
    SET_COLUMNS,
    SET_CONTRACT_IS_DEACTIVATED,
    UPDATE_CONTACT_DETAILS,
    SET_CUSTOM_PROVIDER_PAYMENT_DELAY_EDIT
} from './actionTypes';
import { ProfileActionTypes, SET_PREFERENCES } from '../../profile/redux/actionTypes';
import { cloneDeep } from 'lodash';
import { ADD_CUSTOM_PICTURES, PictureActionTypes } from '../../picture/redux/actionTypes';

const initialState: CustomProviderState = {
    activation_countries: [],
    address: '',
    address_error: '',
    assistance_email: '',
    assistance_phone_number: '',
    auto_booking: false,
    banking_information_create: false,
    banking_information_delete: null,
    banking_information_edit: null,
    banking_information_list: [],
    banking_informations: [],
    booking_email: '',
    booking_email_error: '',
    city: '',
    city_error: '',
    code: '',
    code_create: false,
    code_delete: null,
    code_edit: null,
    code_error: '',
    code_list: [],
    codes: [],
    columns: [{
        label: 'provider-name',
        field_name: 'PROVIDER_NAME',
        checked: true,
        order_by: 'provider__name',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'provider-activated',
        field_name: 'PROVIDER_ACTIVATED',
        checked: true,
        order_by: 'provider__activated',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'content-types',
        field_name: 'CONTENT_TYPE',
        checked: true,
        order_by: '',
        fixed_width: false,
        last_updated: false
    }, {
        label: 'created-date',
        field_name: 'CREATED_DATE',
        checked: false,
        order_by: 'created_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'created-by',
        field_name: 'CREATED_BY',
        checked: false,
        order_by: 'creator__username',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-date',
        field_name: 'MODIFIED_DATE',
        checked: true,
        order_by: 'modified_date',
        fixed_width: true,
        last_updated: false
    }, {
        label: 'modified-by',
        field_name: 'MODIFIED_BY',
        checked: true,
        order_by: 'last_author__username',
        fixed_width: true,
        last_updated: false
    }],
    complementary_address: '',
    complementary_address_error: '',
    contact_details_locales: {},
    contact_details: '',
    contact_email: '',
    contact_email_error: '',
    contact_create: false,
    contact_delete: null,
    contact_edit: null,
    contact_list: [],
    contacts: [],
    content_type: [],
    content_type_error: '',
    contract_activate: null,
    contract_create: false,
    contract_edit: null,
    contract_list: [],
    contract_lock: null,
    contract_is_hidden: null,
    contract_type: '',
    va_content_type: '',
    va_content_type_error: '',
    contract_type_error: '',
    contracts: [],
    count: 0,
    country: '',
    country_error: '',
    create: false,
    custom_provider: null,
    custom_provider_activate: null,
    edit: false,
    edit_step: 'INFO',
    export_full: false,
    export_list: false,
    export_type: 'CSV',
    filter_activated: 'BOTH',
    filter_content_type: [],
    filter_va_content_type: '',
    filter_created_date_gte: null,
    filter_created_date_lte: null,
    filter_creator: '',
    filter_last_author: '',
    filter_modified_date_gte: null,
    filter_modified_date_lte: null,
    filter_name: '',
    filter_open: false,
    filter_period: 'CREATION',
    filter_period_type: 0,
    language: null,
    limit: 50,
    list: null,
    list_contract_reload: null,
    name: '',
    name_error: '',
    order: 'asc',
    order_by: '-created_date',
    page: 0,
    payment_delay_create: false,
    payment_delay_delete: null,
    payment_delay_edit: null,
    payment_delay_list: [],
    payment_delays: [],
    payment_delays_error: [],
    payment_type: ['VOUCHER'],
    payment_type_error: '',
    phone_number: '',
    phone_number_error: '',
    picture: null,
    picture_errors: null,
    picture_progress: 0,
    preferences: [],
    refresh: false,
    running: false,
    search: '',
    secondary_phone_number: '',
    secondary_phone_number_error: '',
    zip_code: '',
    zip_code_error: '',
    editor_pictures: null,
};

const bankingInformation: BankingInformation = {
    address: '',
    address_error: '',
    bic: '',
    bic_error: '',
    city: '',
    city_error: '',
    country: '',
    country_error: '',
    currency: null,
    currency_error: '',
    holder_name: '',
    holder_name_error: '',
    iban: '',
    iban_error: '',
    name: '',
    name_error: '',
    zip_code: '',
    zip_code_error: ''
};

const code: Code = {
    code: '',
    code_error: '',
    currency: null,
    currency_error: ''
};

const contact: Contact = {
    email: '',
    email_error: '',
    first_name: '',
    first_name_error: '',
    function: '',
    function_error: '',
    last_name: '',
    last_name_error: '',
    phone_number: '',
    phone_number_error: ''
};

const contract: Contract = {
    activated: false,
    currency: null,
    currency_error: '',
    end_date: null,
    end_date_error: '',
    is_locked: false,
    name: '',
    name_error: '',
    name_locales: {},
    price_by_schedule: false,
    second_stock_type: null,
    start_date: null,
    start_date_error: '',
    stock_type: 'NORMAL'
};

const paymentDelay: PaymentDelay = {
    currency: null,
    currency_error: '',
    delay_payment: 0,
    delay_error: '',
    delay_negative: false,
    delay_type: 'BOOKING'
};

const updateBankingInformationProperty = (value: any, index: number, state: CustomProviderState, key: string) => {
    const banking_informations = [...state.banking_informations];
    const banking_information = {...banking_informations[index]};
    banking_information[key] = value;
    banking_informations[index] = banking_information;
    return {...state, banking_informations: banking_informations};
};

const updateCodeProperty = (value: any, index: number, state: CustomProviderState, key: string) => {
    const codes = [...state.codes];
    const code = {...codes[index]};
    code[key] = value;
    codes[index] = code;
    return {...state, codes: codes};
};

const updateContactProperty = (value: any, index: number, state: CustomProviderState, key: string) => {
    const contacts = [...state.contacts];
    const contact = {...contacts[index]};
    contact[key] = value;
    contacts[index] = contact;
    return {...state, contacts: contacts};
};

const updateContractProperty = (value: any, index: number, state: CustomProviderState, key: string) => {
    const contracts = [...state.contracts];
    const contract = {...contracts[index]};
    if (key === 'name_locales') {
        const { id, text } = value;
        const name_locales = {...contract.name_locales};
        name_locales[id] = text;
        contract.name_locales = name_locales;
    } else {
        contract[key] = value;
        if (key === 'stock_type' && value !== 'NORMAL') {
            contract.second_stock_type = null;
        }
    }
    contracts[index] = contract;
    return {...state, contracts: contracts};
};



export default (state: CustomProviderState = initialState, action: CustomProviderActionTypes | ProfileActionTypes  | PictureActionTypes): CustomProviderState => {
    switch (action.type) {
        case ADD_BANKING_INFORMATION: {
            const banking_informations = [...state.banking_informations];
            banking_informations.push({...bankingInformation});
            return {...state, banking_informations: banking_informations};
        }
        case ADD_CODE: {
            const codes = [...state.codes];
            codes.push({...code});
            return {...state, codes: codes};
        }
        case ADD_CONTACT: {
            const contacts = [...state.contacts];
            contacts.push({...contact});
            return {...state, contacts: contacts};
        }
        case ADD_CONTRACT: {
            const contracts = [...state.contracts];
            contracts.push({...contract});
            return {...state, contracts: contracts};
        }
        case ADD_PAYMENT_DELAY: {
            return {...state, payment_delays: [...state.payment_delays, null], payment_delays_error: [...state.payment_delays_error, '']};
        }
        case ADD_PREFERENCES: {
            return {...state, preferences: [...state.preferences, ...action.payload]};
        }
        case DELETE_BANKING_INFORMATION: {
            const banking_informations = [...state.banking_informations];
            banking_informations.splice(action.payload, 1);
            return {...state, banking_informations: banking_informations};
        }
        case DELETE_CODE: {
            const codes = [...state.codes];
            codes.splice(action.payload, 1);
            return {...state, codes: codes};
        }
        case DELETE_CONTACT: {
            const contacts = [...state.contacts];
            contacts.splice(action.payload, 1);
            return {...state, contacts: contacts};
        }
        case DELETE_CONTRACT: {
            const contracts = [...state.contracts];
            contracts.splice(action.payload, 1);
            return {...state, contracts: contracts};
        }
        case DELETE_PAYMENT_DELAY: {
            const payment_delays = [...state.payment_delays];
            const payment_delays_error = [...state.payment_delays_error];
            payment_delays.splice(action.payload, 1);
            payment_delays_error.splice(action.payload, 1);
            return {...state, payment_delays, payment_delays_error};
        }
        case MOVE_DOWN_COLUMN: {
            const columns = [...state.columns];
            for (let i = 0; i < columns.length; i++) {
                columns[i].last_updated = false;
            }
            const column = {...columns[action.payload + 1]};
            columns[action.payload + 1] = columns[action.payload];
            columns[action.payload + 1].last_updated = true;
            columns[action.payload] = column;
            return {...state, columns: columns};
        }
        case MOVE_UP_COLUMN: {
            const columns = [...state.columns];
            for (let i = 0; i < columns.length; i++) {
                columns[i].last_updated = false;
            }
            const column = {...columns[action.payload - 1]};
            columns[action.payload - 1] = columns[action.payload];
            columns[action.payload - 1].last_updated = true;
            columns[action.payload] = column;
            return {...state, columns: columns};
        }
        case RESET_FILTERS: {
            return {
                ...state,
                filter_activated: 'BOTH',
                filter_content_type: [],
                filter_va_content_type: '',
                filter_created_date_gte: null,
                filter_created_date_lte: null,
                filter_creator: '',
                filter_last_author: '',
                filter_modified_date_gte: null,
                filter_modified_date_lte: null,
                filter_name: '',
                filter_period: 'CREATION',
                filter_period_type: 0
            };
        }
        case RESET_CUSTOM_PROVIDER: {
            return {
                ...state,
                activation_countries: [],
                address: '',
                address_error: '',
                auto_booking: false,
                banking_informations: [],
                booking_email: '',
                booking_email_error: '',
                city: '',
                city_error: '',
                code: '',
                code_error: '',
                complementary_address: '',
                complementary_address_error: '',
                contact_details_locales: {},
                contact_details: '',
                contact_email: '',
                contact_email_error: '',
                contacts: [],
                content_type: [],
                content_type_error: '',
                contracts: [],
                country: '',
                country_error: '',
                create: false,
                custom_provider: null,
                edit_step: 'INFO',
                language: null,
                name: '',
                name_error: '',
                payment_delays: [],
                payment_type: ['VOUCHER'],
                payment_type_error: '',
                phone_number: '',
                phone_number_error: '',
                picture: null,
                picture_errors: null,
                secondary_phone_number: '',
                secondary_phone_number_error: '',
                zip_code: '',
                zip_code_error: '',
            };
        }
        case SET_BANKING_INFORMATION_DELETE: {
            if (action.payload === false) {
                return {...state, banking_information_delete: null};
            } else if (action.payload === null && state.banking_information_delete !== null) {
                const banking_information_list = [...state.banking_information_list];
                for (let i = 0; i < banking_information_list.length; i++) {
                    if (banking_information_list[i].id === state.banking_information_delete.id) {
                        banking_information_list.splice(i, 1);
                        break;
                    }
                }
                return {...state, banking_information_list: banking_information_list, banking_information_delete: null};
            }
            return {...state, banking_information_delete: action.payload};
        }
        case SET_BANKING_INFORMATION_LIST: {
            return {...state, banking_information_list: action.payload};
        }
        case SET_CODE_DELETE: {
            if (action.payload === false) {
                return {...state, code_delete: null};
            } else if (action.payload === null && state.code_delete !== null) {
                const code_list = [...state.code_list];
                for (let i = 0; i < code_list.length; i++) {
                    if (code_list[i].id === state.code_delete.id) {
                        code_list.splice(i, 1);
                        break;
                    }
                }
                return {...state, code_list: code_list, code_delete: null};
            }
            return {...state, code_delete: action.payload};
        }
        case SET_CODE_LIST: {
            return {...state, code_list: action.payload};
        }
        case SET_CONTACT_DELETE: {
            if (action.payload === false) {
                return {...state, contact_delete: null};
            } else if (action.payload === null && state.contact_delete !== null) {
                const contact_list = [...state.contact_list];
                for (let i = 0; i < contact_list.length; i++) {
                    if (contact_list[i].id === state.contact_delete.id) {
                        contact_list.splice(i, 1);
                        break;
                    }
                }
                return {...state, contact_list: contact_list, contact_delete: null};
            }
            return {...state, contact_delete: action.payload};
        }
        case SET_CONTACT_LIST: {
            return {...state, contact_list: action.payload};
        }
        case SET_CONTRACT_ACTIVATE: {
            if (action.payload === false) {
                return {...state, contract_activate: null};
            } else if (action.payload === null && state.contract_activate !== null) {
                const contract_list = [...state.contract_list];
                for (let i = 0; i < contract_list.length; i++) {
                    if (contract_list[i].id === state.contract_activate.id) {
                        let contract = {...contract_list[i]};
                        contract.activated = !contract.activated;
                        contract_list[i] = contract;
                        break;
                    }
                }
                return {...state, list_contract_reload: state.contract_activate.id, contract_list: contract_list, contract_activate: null};
            }
            return {...state, contract_activate: action.payload};
        }
        case SET_CONTRACT_LIST: {
            return {...state, contract_list: action.payload};
        }
        case SET_CONTRACT_LOCK: {
            if (action.payload === false) {
                return {...state, contract_lock: null};
            } else if (action.payload === null && state.contract_lock !== null) {
                const contract_list = [...state.contract_list];
                for (let i = 0; i < contract_list.length; i++) {
                    if (contract_list[i].id === state.contract_lock.id) {
                        let contract = {...contract_list[i]};
                        contract.is_locked = !contract.is_locked;
                        contract_list[i] = contract;
                        break;
                    }
                }
                return {...state, list_contract_reload: state.contract_lock.id, contract_list: contract_list, contract_lock: null};
            }
            return {...state, contract_lock: action.payload};
        }
        case SET_CONTRACT_IS_DEACTIVATED: {
            if (action.payload === false) {
                return {...state, contract_is_hidden: null};
            } else if (action.payload === null && state.contract_is_hidden !== null) {
                const contract_list = [...state.contract_list];
                for (let i = 0; i < contract_list.length; i++) {
                    if (contract_list[i].id === state.contract_is_hidden.id) {
                        const contract = {...contract_list[i]};
                        contract.is_hidden = !contract.is_hidden;
                        contract_list[i] = contract;
                        break;
                    }
                }
                return {...state, list_contract_reload: state.contract_is_hidden.id, contract_list: contract_list, contract_is_hidden: null};
            }
            return {...state, contract_is_hidden: action.payload};
        }
        case SET_CUSTOM_PROVIDER: {
            const localized_contact_details: {} & {[index: number]: any} = {};
            localized_contact_details[1] = action.payload.contact_details !== null ? action.payload.contact_details : '';
            return {
                ...state,
                edit: false,
                activation_countries: action.payload.activation_countries,
                address: action.payload.street !== null ? action.payload.street : '',
                auto_booking: action.payload.auto_reservation_email,
                booking_email: action.payload.reservation_email !== null ? action.payload.reservation_email : '',
                city: action.payload.city !== null ? action.payload.city : '',
                code: action.payload.accounting_reference !== null ? action.payload.accounting_reference : '',
                complementary_address: action.payload.street2 !== null ? action.payload.street2 : '',
                contact_details_locales: localized_contact_details,
                contact_details: action.payload.contact_details || '',
                assistance_email: action.payload.assistance_email || '',
                assistance_phone_number: action.payload.assistance_phone_number || '',
                contact_email: action.payload.email !== null ? action.payload.email : '',
                content_type: action.payload.available_content_types,
                va_content_type: action.payload.va_content_type,
                contract_type: action.payload.contract_type,
                country: action.payload.country !== null ? action.payload.country : '',
                custom_provider: action.payload,
                language: action.payload.locale_code,
                name: action.payload.provider.name,
                payment_type: action.payload.accepted_payment_form,
                phone_number: action.payload.phone_number !== null ? action.payload.phone_number : '',
                picture: action.payload.provider.logo,
                secondary_phone_number: action.payload.phone_number_2 !== null ? action.payload.phone_number_2 : '',
                zip_code: action.payload.zip_code !== null ? action.payload.zip_code : '',
            };
        }
        case SET_CUSTOM_PROVIDER_ACTIVATE: {
            if (action.payload === false) {
                return {...state, custom_provider_activate: null};
            } else if (action.payload === null && state.custom_provider_activate !== null && state.list !== null) {
                const list = [...state.list];
                let count = state.count;
                for (let i = 0; i < list.length; i++) {
                    if (list[i].id === state.custom_provider_activate.id) {
                        const item = {...list[i]};
                        item.provider.is_activated = !item.provider.is_activated;
                        list[i] = item;
                        if (state.filter_activated !== 'BOTH') {
                            list.splice(i, 1);
                            count--;
                        }
                        break;
                    }
                }
                return {...state, list: list, count: count, custom_provider_activate: null};
            }
            return {...state, custom_provider_activate: action.payload};
        }
        case SET_CUSTOM_PROVIDER_BANKING_INFORMATIONS: {
            if (action.payload === true) {
                return {...state, banking_information_edit: null, banking_information_create: true, banking_informations: [{...bankingInformation}]};
            } else if (action.payload === false) {
                return {...state, banking_information_edit: null, banking_information_create: false, banking_informations: []};
            } else if (action.payload === null) {
                const banking_information_list = [...state.banking_information_list];
                if (state.banking_information_edit !== null) {
                    for (let i = 0; i < banking_information_list.length; i++) {
                        if (banking_information_list[i].id === state.banking_information_edit.id) {
                            banking_information_list[i] = {...state.banking_informations[0]};
                            banking_information_list[i].bank_name = banking_information_list[i].name;
                            banking_information_list[i].street = banking_information_list[i].address;
                            break;
                        }
                    }
                }
                return {...state, banking_information_create: false, banking_information_edit: null, banking_information_list: banking_information_list, banking_informations: []};
            } else if (state.banking_information_create) {
                const banking_information_list = [...state.banking_information_list];
                banking_information_list.push(action.payload);
                return {...state, banking_information_create: false, banking_information_edit: null, banking_informations: [], banking_information_list: banking_information_list};
            } else {
                const banking_information = action.payload;
                banking_information.address = banking_information.street !== null ? banking_information.street : '';
                banking_information.address_error = '';
                banking_information.bic = banking_information.bic !== null ? banking_information.bic : '';
                banking_information.bic_error = '';
                banking_information.city = banking_information.city !== null ? banking_information.city : '';
                banking_information.city_error = '';
                banking_information.country = banking_information.country !== null ? banking_information.country : '';
                banking_information.country_error = '';
                banking_information.currency_error = '';
                banking_information.holder_name = banking_information.holder_name !== null ? banking_information.holder_name : '';
                banking_information.holder_name_error = '';
                banking_information.iban = banking_information.iban !== null ? banking_information.iban : '';
                banking_information.iban_error = '';
                banking_information.name = banking_information.bank_name !== null ? banking_information.bank_name : '';
                banking_information.name_error = '';
                banking_information.zip_code = banking_information.zip_code !== null ? banking_information.zip_code : '';
                banking_information.zip_code_error = '';
                return {...state, banking_information_create: false, banking_information_edit: action.payload, banking_informations: [{...banking_information}]};
            }
        }
        case SET_CUSTOM_PROVIDER_CODES: {
            if (action.payload === true) {
                return {...state, code_edit: null, code_create: true, codes: [{...code}]};
            } else if (action.payload === false) {
                return {...state, code_edit: null, code_create: false, codes: []};
            } else if (action.payload === null) {
                const code_list = [...state.code_list];
                if (state.code_edit !== null) {
                    for (let i = 0; i < code_list.length; i++) {
                        if (code_list[i].id === state.code_edit.id) {
                            code_list[i] = {...state.codes[0]};
                            break;
                        }
                    }
                }
                return {...state, code_create: false, code_edit: null, code_list: code_list, codes: []};
            } else if (state.code_create) {
                const code_list = [...state.code_list];
                code_list.push(action.payload);
                return {...state, code_create: false, code_edit: null, codes: [], code_list: code_list};
            } else {
                const code = action.payload;
                code.code = '';
                code.currency = null;
                return {...state, code_create: false, code_edit: action.payload, codes: [{...code}]};
            }
        }
        case SET_CUSTOM_PROVIDER_CONTACTS: {
            if (action.payload === true) {
                return {...state, contact_edit: null, contact_create: true, contacts: [{...contact}]};
            } else if (action.payload === false) {
                return {...state, contact_edit: null, contact_create: false, contacts: []};
            } else if (action.payload === null) {
                const contact_list = [...state.contact_list];
                if (state.contact_edit !== null) {
                    for (let i = 0; i < contact_list.length; i++) {
                        if (contact_list[i].id === state.contact_edit.id) {
                            contact_list[i] = {...state.contacts[0]};
                            break;
                        }
                    }
                }
                return {...state, contact_create: false, contact_edit: null, contact_list: contact_list, contacts: []};
            } else if (state.contact_create) {
                const contact_list = [...state.contact_list];
                contact_list.push(action.payload);
                return {...state, contact_create: false, contact_edit: null, contacts: [], contact_list: contact_list};
            } else {
                const contact = action.payload;
                contact.first_name_error = '';
                contact.last_name_error = '';
                contact.function_error = '';
                contact.email_error = '';
                contact.phone_number_error = '';
                return {...state, contact_create: false, contact_edit: action.payload, contacts: [{...contact}]};
            }
        }
        case SET_CUSTOM_PROVIDER_CONTRACTS: {
            if (action.payload === true) {
                return {...state, contract_edit: null, contract_create: true, contracts: [{...contract}]};
            } else if (action.payload === false) {
                return {...state, contract_edit: null, contract_create: false, contracts: []};
            } else if (action.payload === null) {
                const contract_list = [...state.contract_list];
                if (state.contract_edit !== null) {
                    for (let i = 0; i < contract_list.length; i++) {
                        if (contract_list[i].id === state.contract_edit.id) {
                            contract_list[i] = {...state.contracts[0]};
                            break;
                        }
                    }
                }
                return {...state, contract_create: false, contract_edit: null, contract_list: contract_list, contracts: []};
            } else if (state.contract_create) {
                const contract_list = [...state.contract_list];
                contract_list.push(action.payload);
                return {...state, contract_create: false, contract_edit: null, contracts: [], contract_list: contract_list};
            } else {
                const contract = action.payload;
                const localized_name: {} & {[index: number]: any} = {};
                contract.localization.map(locale => {
                    localized_name[locale.locale] = locale.name;
                });
                contract.name_locales = localized_name;
                contract.name_error = '';
                contract.end_date = contract.end_date !== null ? new Date(contract.end_date) : null;
                contract.start_date = contract.start_date !== null ? new Date(contract.start_date) : null;
                contract.start_date_error = '';
                contract.currency_error = '';
                contract.end_date_error = '';
                return {...state, contract_create: false, contract_edit: action.payload, contracts: [{...contract}]};
            }
        }
        case SET_CUSTOM_PROVIDER_PAYMENT_DELAY_EDIT: {
            return {...state, payment_delay_edit: action.payload};
        }
        case SET_CUSTOM_PROVIDER_PAYMENT_DELAYS: {
            return {...state, custom_provider: state.custom_provider ?  { ...state.custom_provider, payment_delays: action.payload }: null };
        }
        // case SET_CUSTOM_PROVIDER_PAYMENT_DELAYS: {
        //     if (action.payload === true) {
        //         return {...state, payment_delay_edit: null, payment_delay_create: true, payment_delays: [{...paymentDelay}]};
        //     } else if (action.payload === false) {
        //         return {...state, payment_delay_edit: null, payment_delay_create: false, payment_delays: []};
        //     } else if (action.payload === null) {
        //         // TODO update payment_delay list
        //         let payment_delay_list = [...state.payment_delay_list];
        //         if (state.payment_delay_edit !== null) {
        //             for (let i = 0; i < payment_delay_list.length; i++) {
        //                 if (payment_delay_list[i].id === state.payment_delay_edit.id) {
        //                     payment_delay_list[i] = {...state.payment_delays[0]};
        //                     break;
        //                 }
        //             }
        //         }
        //         return {...state, payment_delay_create: false, payment_delay_edit: null, payment_delay_list: payment_delay_list, payment_delays: []};
        //     } else if (state.payment_delay_create) {
        //         let payment_delay_list = [...state.payment_delay_list];
        //         payment_delay_list.push(action.payload);
        //         return {...state, payment_delay_create: false, payment_delay_edit: null, payment_delays: [], payment_delay_list: payment_delay_list};
        //     } else {
        //         let payment_delay = action.payload;
        //         payment_delay.currency_error = '';
        //         payment_delay.delay_error = '';
        //         return {...state, payment_delay_create: false, payment_delay_edit: action.payload, payment_delays: [{...payment_delay}]};
        //     }
        // }
        case SET_CUSTOM_PROVIDER_PREFERENCES: {
            return {...state, preferences: action.payload};
        }
        case SET_EDIT_STEP: {
            return {...state, edit_step: action.payload};
        }
        case SET_ERRORS: {
            const errors = action.payload;
            const new_state: CustomProviderState = {...state};
            errors.map(error => {
                if (error.subkey !== undefined && error.subkey_index !== undefined) {
                    const property = [...new_state[error.key]];
                    const sub_property = {...property[error.subkey_index]};
                    sub_property[error.subkey] = error.error;
                    property[error.subkey_index] = sub_property;
                    new_state[error.key] = property;
                } else if(error.subkey === undefined && error.subkey_index !== undefined){
                    const arr = cloneDeep(new_state[error.key]);
                    arr[error.subkey_index] = error.error;
                    new_state[error.key] = arr;
                } else {
                    new_state[error.key] = error.error;
                }
            });
            return {...new_state};
        }
        case SET_EXPORT_TYPE: {
            return {...state, export_type: action.payload};
        }
        case SET_LIMIT: {
            return {...state, list: null, limit: action.payload};
        }
        case SET_LIST: {
            const { count, results } = action.payload;
            return {...state, count: count, list: results, running: false};
        }
        case SET_LIST_CONTRACT_RELOAD: {
            return {...state, list_contract_reload: action.payload};
        }
        case SET_ORDER_BY: {
            return {...state, list: null, order_by: action.payload, order: state.order_by === action.payload && state.order === 'asc' ? 'desc': 'asc' };
        }
        case SET_PAGE: {
            return {...state, list: null, page: action.payload};
        }
        case SET_PAYMENT_DELAYS_DELETE: {
            return {...state, payment_delay_delete: action.payload};
        }
        case SET_PICTURE_ERRORS: {
            return {...state, picture_progress: 0, picture_errors: action.payload};
        }
        case SET_POST_FINISHED: {
            return {
                ...state,
                activation_countries: [],
                address: '',
                address_error: '',
                auto_booking: false,
                banking_informations: [],
                booking_email: '',
                booking_email_error: '',
                city: '',
                city_error: '',
                code: '',
                code_error: '',
                complementary_address: '',
                complementary_address_error: '',
                contact_details_locales: {},
                contact_email: '',
                contact_email_error: '',
                contacts: [],
                content_type: [],
                content_type_error: '',
                contracts: [],
                country: '',
                country_error: '',
                create: false,
                custom_provider: null,
                edit_step: 'INFO',
                language: null,
                name: '',
                name_error: '',
                payment_delays: [],
                payment_type: ['VOUCHER'],
                payment_type_error: '',
                phone_number: '',
                phone_number_error: '',
                picture: null,
                picture_errors: null,
                refresh: !state.refresh,
                secondary_phone_number: '',
                secondary_phone_number_error: '',
                zip_code: '',
                zip_code_error: '',
            };
        }
        case SET_PREFERENCES: {
            const preferences = action.payload;
            const new_columns: Column[] = [];
            let new_order_by = '-created_date';
            let new_order: 'asc' | 'desc' = 'asc';
            const field_name: string[] = [];
            const custom_provider_preferences: Preferences[] = [];
            preferences.map(preference => {
                if (preference.module === 'CUSTOM_PROVIDER') {
                    if (!field_name.includes(preference.field_name)) {
                        switch (preference.field_name) {
                            case 'PROVIDER_ACTIVATED':
                                new_columns.push({label: 'provider-activated', field_name: preference.field_name, checked: preference.active, order_by: 'provider__activated', fixed_width: false, last_updated: false});
                                new_order_by = preference.ordering_asc !== null ? 'provider__activated' : new_order_by;
                                break;
                            case 'PROVIDER_NAME':
                                new_columns.push({label: 'provider-name', field_name: preference.field_name, checked: preference.active, order_by: 'provider__name', fixed_width: false, last_updated: false});
                                new_order_by = preference.ordering_asc !== null ? 'provider__name' : new_order_by;
                                break;
                            case 'CONTENT_TYPE':
                                new_columns.push({label: 'content-types', field_name: preference.field_name, checked: preference.active, order_by: '', fixed_width: false, last_updated: false});
                                break;
                            case 'CREATED_DATE':
                                new_columns.push({label: 'created-date', field_name: preference.field_name, checked: preference.active, order_by: 'created_date', fixed_width: true, last_updated: false});
                                new_order_by = preference.ordering_asc !== null ? 'created_date' : new_order_by;
                                break;
                            case 'CREATED_BY':
                                new_columns.push({label: 'created-by', field_name: preference.field_name, checked: preference.active, order_by: 'creator__username', fixed_width: false, last_updated: false});
                                new_order_by = preference.ordering_asc !== null ? 'creator__username' : new_order_by;
                                break;
                            case 'MODIFIED_DATE':
                                new_columns.push({label: 'modified-date', field_name: preference.field_name, checked: preference.active, order_by: 'modified_date', fixed_width: true, last_updated: false});
                                new_order_by = preference.ordering_asc !== null ? 'modified_date' : new_order_by;
                                break;
                            case 'MODIFIED_BY':
                                new_columns.push({label: 'modified-by', field_name: preference.field_name, checked: preference.active, order_by: 'last_author__username', fixed_width: false, last_updated: false});
                                new_order_by = preference.ordering_asc !== null ? 'last_author__username' : new_order_by;
                                break;
                            default:
                                break;
                        }
                        custom_provider_preferences.push(preference);
                        field_name.push(preference.field_name);
                        new_order = preference.ordering_asc !== null ? preference.ordering_asc ? 'asc' : 'desc' : new_order;
                    }
                }
            });
            if (new_columns.length !== state.columns.length) {
                state.columns.map(column => {
                    let added = false;
                    for (let i = 0; i < new_columns.length; i++) {
                        if (new_columns[i].label === column.label) {
                            added = true;
                            break;
                        }
                    }
                    if (!added) {
                        new_columns.push({...column});
                    }
                });
            }
            return {...state, preferences: custom_provider_preferences, columns: new_columns, order_by: new_order_by, order: new_order};
        }
        case SET_RUNNING: {
            return {...state, running: action.payload};
        }
        case SET_SEARCH: {
            return {...state, list: null, page: 0, search: action.payload};
        }
        case TOGGLE_AUTO_BOOKING: {
            return {...state, auto_booking: !state.auto_booking};
        }
        case TOGGLE_COLUMN: {
            const columns = [...state.columns];
            const column = {...columns[action.payload]};
            column.checked = !column.checked;
            columns[action.payload] = column;
            return {...state, columns: columns};
        }
        case TOGGLE_CREATE: {
            return {...state, create: !state.create};
        }
        case TOGGLE_EDIT: {
            return {...state, edit: !state.edit};
        }
        case TOGGLE_EXPORT: {
            return {...state, export_list: action.payload};
        }
        case TOGGLE_EXPORT_FULL: {
            return {...state, export_full: !state.export_full};
        }
        case TOGGLE_FILTERS: {
            return {...state, filter_open: !state.filter_open};
        }
        case TOGGLE_REFRESH: {
            return {...state, refresh: !state.refresh};
        }
        case UPDATE_ACTIVATION_COUNTRIES: {
            return {...state, activation_countries: action.payload};
        }
        case UPDATE_ADDRESS: {
            return {...state, address: action.payload};
        }
        case UPDATE_ASSISTANCE_EMAIL: {
            return {...state, assistance_email: action.payload};
        }
        case UPDATE_ASSISTANCE_PHONE_NUMBER: {
            return {...state, assistance_phone_number: action.payload};
        }
        case UPDATE_BANKING_ACCOUNT_HOLDER: {
            const { value, index } = action.payload;
            return updateBankingInformationProperty(value, index, state, 'holder_name');
        }
        case UPDATE_BANKING_ADDRESS: {
            const { value, index } = action.payload;
            return updateBankingInformationProperty(value, index, state, 'address');
        }
        case UPDATE_BANKING_BIC: {
            const { value, index } = action.payload;
            return updateBankingInformationProperty(value, index, state, 'bic');
        }
        case UPDATE_BANKING_CITY: {
            const { value, index } = action.payload;
            return updateBankingInformationProperty(value, index, state, 'city');
        }
        case UPDATE_BANKING_COUNTRY: {
            const { value, index } = action.payload;
            return updateBankingInformationProperty(value, index, state, 'country');
        }
        case UPDATE_BANKING_CURRENCY: {
            const { value, index } = action.payload;
            return updateBankingInformationProperty(value, index, state, 'currency');
        }
        case UPDATE_BANKING_IBAN: {
            const { value, index } = action.payload;
            return updateBankingInformationProperty(value, index, state, 'iban');
        }
        case UPDATE_BANKING_NAME: {
            const { value, index } = action.payload;
            return updateBankingInformationProperty(value, index, state, 'name');
        }
        case UPDATE_BANKING_ZIP_CODE: {
            const { value, index } = action.payload;
            return updateBankingInformationProperty(value, index, state, 'zip_code');
        }
        case UPDATE_BOOKING_EMAIL: {
            return {...state, booking_email: action.payload};
        }
        case UPDATE_CITY: {
            return {...state, city: action.payload};
        }
        case UPDATE_CODE: {
            return {...state, code: action.payload};
        }
        case UPDATE_CODE_CODE: {
            const { value, index } = action.payload;
            return updateCodeProperty(value, index, state, 'code');
        }
        case UPDATE_CODE_CURRENCY: {
            const { value, index } = action.payload;
            return updateCodeProperty(value, index, state, 'currency');
        }
        case UPDATE_COMPLEMENTARY_ADDRESS: {
            return {...state, complementary_address: action.payload};
        }
        case UPDATE_CONTACT_CONTACT_EMAIL: {
            const { value, index } = action.payload;
            return updateContactProperty(value, index, state, 'email');
        }
        case UPDATE_CONTACT_DETAILS_LOCALE: {
            const { id, value } = action.payload;
            const contact_details_locales = { ...state.contact_details_locales };
            contact_details_locales[id] = value;
            return { ...state, contact_details_locales: contact_details_locales };
        }
        case UPDATE_CONTACT_DETAILS: {
            return {...state, contact_details: action.payload};
        }
        case UPDATE_CONTACT_EMAIL: {
            return {...state, contact_email: action.payload};
        }
        case UPDATE_CONTACT_FIRST_NAME: {
            const { value, index } = action.payload;
            return updateContactProperty(value, index, state, 'first_name');
        }
        case UPDATE_CONTACT_FUNCTION: {
            const { value, index } = action.payload;
            return updateContactProperty(value, index, state, 'function');
        }
        case UPDATE_CONTACT_LAST_NAME: {
            const { value, index } = action.payload;
            return updateContactProperty(value, index, state, 'last_name');
        }
        case UPDATE_CONTACT_PHONE_NUMBER: {
            const { value, index } = action.payload;
            return updateContactProperty(value, index, state, 'phone_number');
        }
        case UPDATE_CONTENT_TYPE: {
            return {...state, content_type: action.payload};
        }
        case UPDATE_CONTRACT_CURRENCY: {
            const { value, index } = action.payload;
            return updateContractProperty(value, index, state, 'currency');
        }
        case UPDATE_CONTRACT_EVENT_SITE_DATE : {
            const { value, index } = action.payload;
            return updateContractProperty(value, index, state, 'event_site_date');
        }
        case UPDATE_CONTRACT_END_DATE: {
            const { value, index } = action.payload;
            return updateContractProperty(value, index, state, 'end_date');
        }
        case UPDATE_CONTRACT_NAME: {
            const { value, index } = action.payload;
            return updateContractProperty(value, index, state, 'name');
        }
        case UPDATE_CONTRACT_SECOND_STOCK_TYPE: {
            const { value, index } = action.payload;
            return updateContractProperty(value, index, state, 'second_stock_type');
        }
        case UPDATE_CONTRACT_START_DATE: {
            const { value, index } = action.payload;
            return updateContractProperty(value, index, state, 'start_date');
        }
        case UPDATE_CONTRACT_STOCK_TYPE: {
            const { value, index } = action.payload;
            return updateContractProperty(value, index, state, 'stock_type');
        }
        case UPDATE_CONTRACT_TYPE: {
            return {...state, contract_type: action.payload};
        }
        case UPDATE_VA_CONTENT_TYPE: {
            return {...state, va_content_type: action.payload};
        }
        case UPDATE_COUNTRY: {
            return {...state, country: action.payload};
        }
        case UPDATE_FILTER_ACTIVATED: {
            return {...state, filter_activated: action.payload};
        }
        case UPDATE_FILTER_CONTENT_TYPE: {
            return {...state, filter_content_type: action.payload};
        }
        case UPDATE_FILTER_VA_CONTENT_TYPE: {
            return {...state, filter_va_content_type: action.payload};
        }
        case UPDATE_FILTER_CREATED_DATE_GTE: {
            return {...state, filter_created_date_gte: action.payload};
        }
        case UPDATE_FILTER_CREATED_DATE_LTE: {
            return {...state, filter_created_date_lte: action.payload};
        }
        case UPDATE_FILTER_CREATOR: {
            return {...state, filter_creator: action.payload};
        }
        case UPDATE_FILTER_LAST_AUTHOR: {
            return {...state, filter_last_author: action.payload};
        }
        case UPDATE_FILTER_MODIFIED_DATE_GTE: {
            return {...state, filter_modified_date_gte: action.payload};
        }
        case UPDATE_FILTER_MODIFIED_DATE_LTE: {
            return {...state, filter_modified_date_lte: action.payload};
        }
        case UPDATE_FILTER_NAME: {
            return {...state, filter_name: action.payload};
        }
        case UPDATE_FILTER_PERIOD: {
            const period = action.payload;
            return {
                ...state,
                filter_period: period,
                filter_period_type: 0,
                filter_created_date_gte: period === 'MODIFICATION' ? null : state.filter_created_date_gte,
                filter_created_date_lte: period === 'MODIFICATION' ? null : state.filter_created_date_lte,
                filter_modified_date_gte: period === 'CREATION' ? null : state.filter_modified_date_gte,
                filter_modified_date_lte: period === 'CREATION' ? null : state.filter_modified_date_lte,
            };
        }
        case UPDATE_FILTER_PERIOD_TYPE: {
            return {...state, filter_period_type: action.payload};
        }
        case UPDATE_LANGUAGE: {
            return {...state, language: action.payload === 'null' ? null : action.payload};
        }
        case UPDATE_NAME: {
            return {...state, name: action.payload};
        }
        case UPDATE_PAYMENT_DELAY: {
            const { value, index } = action.payload;
            const payment_delays = cloneDeep(state.payment_delays);
            const payment_delays_error = cloneDeep(state.payment_delays_error);
            payment_delays[index] = value;
            payment_delays_error[index] = '';
            return {...state, payment_delays, payment_delays_error};
        }
        case UPDATE_PAYMENT_TYPE: {
            return {...state, payment_type: action.payload};
        }
        case UPDATE_PHONE_NUMBER: {
            return {...state, phone_number: action.payload};
        }
        case UPDATE_PICTURE: {
            return {...state, picture_progress: 0, picture: action.payload};
        }
        case UPDATE_PICTURE_PROGRESS: {
            return {...state, picture_progress: action.payload};
        }
        case UPDATE_SECONDARY_PHONE_NUMBER: {
            return {...state, secondary_phone_number: action.payload};
        }
        case UPDATE_ZIP_CODE: {
            return {...state, zip_code: action.payload};
        }
        case SET_PAYMENT_DELAY_CREATE: {
            return {...state, payment_delay_create: action.payload};
        }
        case UPDATE_CONTRACT_NAME_LOCALE: {
            const {index, value } = action.payload;
            const new_contract = cloneDeep(state.contracts[index]);
            if(!new_contract.name_locales){
                new_contract.name_locales = {}
            }
            new_contract.name_locales[value.id] = value.text;
            return {...state, contracts: state.contracts.map((contract, contract_index) => contract_index === index? new_contract: contract)};
        }
        case SET_COLUMNS: {
            return {...state, columns: action.payload};
        }
        case ADD_CUSTOM_PICTURES: {
            return {...state, editor_pictures: action.payload};
        }
        default:
            return state;
    }
};